import React, { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

const BarcodeLabel: React.FC<{
  fnsku: string;
  itemName: string;
  index: number;
  total: number;
}> = ({ fnsku, itemName, index, total }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (canvasRef.current) {
      JsBarcode(canvasRef.current, fnsku, {
        format: "CODE128",
        displayValue: true,
        fontSize: 16,
        fontOptions: "bold",
        width: 2,
        height: 70,
        margin: 0,
      });
    }
  }, [fnsku]);

  return (
    <div
      style={{
        width: "50mm",
        height: "30mm",
        padding: "2mm",
        margin: "0 auto",
        pageBreakAfter: "always",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        boxSizing: "border-box",
      }}
    >
      <canvas ref={canvasRef} style={{ width: "100%", marginBottom: "1px" }} />
      <div
        style={{
          fontSize: "11px",
          fontWeight: 800,
          textAlign: "center",
          lineHeight: "1.2",
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          wordBreak: "break-word",
          width: "100%",
          marginTop: "2.5px",
          fontFamily: '"Arial Black", "BIZ UD Gothic", "Meiryo", sans-serif',
        }}
      >
        {itemName}
      </div>
      <div
        style={{
          position: "absolute",
          bottom: "2mm",
          right: "2mm",
          fontSize: "10px",
        }}
      >
        {`${index + 1}`}
      </div>
    </div>
  );
};

const PrintLabelsPage: React.FC<{
  fnsku: string;
  itemName: string;
  count: number;
}> = ({ fnsku, itemName, count }) => {
  useEffect(() => {
    window.onafterprint = () => {
      if (window.opener) {
        window.opener.focus();
      }
      window.close();
    };

    setTimeout(() => {
      window.print();
    }, 500);
  }, []);

  return (
    <div
      style={{
        width: "100%",
        margin: 0,
        padding: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {[...Array(count)].map((_, i) => (
        <BarcodeLabel
          key={i}
          fnsku={fnsku}
          itemName={itemName}
          index={i}
          total={count}
        />
      ))}
      <style>{`
        @page {
          size: 50mm 30mm;
          margin: 0;
        }

        @media print {
          body {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
            margin: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default PrintLabelsPage;
